module.exports = __webpack_public_path__ + "img/nfc.eeba94f3.png";